var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ELSCommonUIConstants, withHTMLHeadSEO, withLoading } from 'components/common';
import TableFilter from 'components/common/table-filter/TableFilter';
import withResizeScreen from 'components/common/with-resize-screen/withResizeScreen';
import { ANALYTIC_FEATURES, FeatureFlagNames } from 'constants/app.constant';
import { pluralizeUnit, renderNoDataFound, renderNoResultsFound } from 'helpers/ui.helper';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { appSelectors } from 'redux/ducks/app';
import { filterActions, filterSelectors } from 'redux/ducks/filter';
import { ASSIGNMENT_TYPE_GROUPS, getAssignmentTypeById } from 'reports/cw/constants/report.constant';
import { getIsOsmosisAssignment, isEABAssignment } from 'reports/cw/helpers/report.helper';
import { cwSelectors } from 'reports/cw/redux/ducks/cw';
import { remapFieldsForEngagementReport } from 'reports/cw/services/report.service';
import { trackAAEvent } from 'services/adobe-analytics.service';
import { isFeatureEnabled } from 'services/feature-flag.service';
import StudentEngagementTableMobile from './student-engagement-table-mobile/StudentEngagementTableMobile';
import StudentEngagementTable from './student-engagement-table/StudentEngagementTable';
var StudentEngagementComponent = /** @class */ (function (_super) {
    __extends(StudentEngagementComponent, _super);
    function StudentEngagementComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSearch = function (searchKeyword) {
            _this.props.setSearchKeyword(searchKeyword);
            trackAAEvent(ELSCommonUIConstants.analytics.eventTypes.productFeatureUsed, {
                feature: {
                    name: ANALYTIC_FEATURES.CW_COURSE_SUMMARY_ENGAGEMENT_ASSIGNMENT_DETAILS_STUDENT_TAB_STUDENT_SEARCH
                },
                searchText: searchKeyword
            });
        };
        _this.filterTableData = function (isEAQAssignmentType) {
            var _a = _this.props, _b = _a.studentEngagement, avgTimeOfClassOnQuestions = _b.avgTimeOfClassOnQuestions, _c = _b.metrics, metrics = _c === void 0 ? [] : _c, searchKeyword = _a.searchKeyword;
            return metrics
                .map(function (item) { return remapFieldsForEngagementReport(item, avgTimeOfClassOnQuestions, isEAQAssignmentType); })
                .filter(function (item) { return item.studentName.toLowerCase().includes(searchKeyword.toLowerCase().trim()); });
        };
        return _this;
    }
    StudentEngagementComponent.prototype.render = function () {
        var _a, _b, _c;
        var _d = this.props, studentEngagement = _d.studentEngagement, assignmentTypeId = _d.assignmentTypeId, filteredAssignmentEngagement = _d.filteredAssignmentEngagement, searchKeyword = _d.searchKeyword, windowMode = _d.windowMode, isGradePointsHidden = _d.isGradePointsHidden, featureFlags = _d.featureFlags, selectedAssignmentTypeId = _d.selectedAssignmentTypeId;
        if (((studentEngagement === null || studentEngagement === void 0 ? void 0 : studentEngagement.metrics) || []).length === 0) {
            return renderNoDataFound();
        }
        var avgScoreOfClass = studentEngagement.avgScoreOfClass;
        var assignmentTypeName = (_b = (_a = getAssignmentTypeById(assignmentTypeId)) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '';
        var isStudentTotalGradePointsHidden = isGradePointsHidden || (isEABAssignment(selectedAssignmentTypeId) && isFeatureEnabled(featureFlags, FeatureFlagNames.EAB_GRADEPOINTS_ENABLED));
        var isEAQAssignmentType = ((_c = getAssignmentTypeById(assignmentTypeId)) === null || _c === void 0 ? void 0 : _c.group) === ASSIGNMENT_TYPE_GROUPS.EAQ;
        var isOsmosisAssignmentType = getIsOsmosisAssignment(assignmentTypeId);
        var tableData = this.filterTableData(isEAQAssignmentType);
        var numberOfStudents = tableData.length;
        var numberOfAssignments = filteredAssignmentEngagement.length;
        var studentEngagementTableProps = {
            avgScoreOfClass: avgScoreOfClass,
            tableData: tableData,
            isEAQAssignmentType: isEAQAssignmentType,
            isOsmosisAssignmentType: isOsmosisAssignmentType,
            isGradePointsHidden: isStudentTotalGradePointsHidden
        };
        return (<div className="c-cw-student-engagement">
        <TableFilter filterHidden searchKeyword={searchKeyword} onSearch={this.onSearch} searchPlaceholder="Search by student name" customClass="u-els-margin-top-2x u-els-margin-bottom-2x u-els-margin-bottom-1x@mobile">
          <h4 className="c-cw-student-engagement__header">
            <span>{"Showing "}</span>
            <strong>{numberOfStudents}</strong>
            <span>{" student".concat(numberOfStudents === 1 ? "'s" : "s'", " engagement in ")}</span>
            <strong>{"".concat(numberOfAssignments, " ").concat(assignmentTypeName, " ")}</strong>
            <span>{"".concat(pluralizeUnit(numberOfAssignments, 'assignment'), ", including self-study")}</span>
          </h4>
        </TableFilter>
        {windowMode.mobile ? <StudentEngagementTableMobile {...studentEngagementTableProps}/> : <StudentEngagementTable {...studentEngagementTableProps}/>}
        {tableData.length === 0 && renderNoResultsFound()}
      </div>);
    };
    return StudentEngagementComponent;
}(Component));
export { StudentEngagementComponent };
var mapStateToProps = function (state) { return ({
    studentEngagement: cwSelectors.getStudentEngagement(state),
    searchKeyword: filterSelectors.getCWStudentEngagementTableSearch(state),
    selectedAssignmentTypeId: filterSelectors.getCWEngagementAssignmentTypeDropdownId(state),
    featureFlags: appSelectors.getFeatureFlags(state)
}); };
var mapDispatchToProps = function (dispatch) { return ({
    setSearchKeyword: function (searchKeyword) { return dispatch(filterActions.setCWStudentEngagementTableSearch(searchKeyword)); }
}); };
var enhancers = [withHTMLHeadSEO({ title: 'Student Engagement & Grades' }), withLoading, withRouter, connect(mapStateToProps, mapDispatchToProps), withResizeScreen];
export { StudentEngagementComponent as StudentEngagementComponentBase };
export default compose.apply(void 0, enhancers)(StudentEngagementComponent);
